import { WorkspaceWindowTypeEnumType } from '@mark43/cad-api';
import React from 'react';

export type ElectronWindows = { workspaceWindowType: WorkspaceWindowTypeEnumType }[];
export const ElectronWindowsContext = React.createContext<
    { workspaceWindowType: WorkspaceWindowTypeEnumType }[]
>([]);
